import CloseIcon from '@mui/icons-material/Close';
import { Alert, Collapse } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import React, { useEffect } from 'react';

export const ErrorPopup = ({ message, open, setOpen }) => {
  useEffect(() => {
    let timer;
    if (open) {
      timer = setTimeout(() => {
        setOpen(false);
      }, 5000);
    }

    return () => clearTimeout(timer);
  }, [open, setOpen]);

  return (
    <Collapse in={open}>
      <Alert
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ mb: 2 }}
        severity="error"
      >
        {message}
      </Alert>
    </Collapse>
  );
};
